import React from "react";

import { Auth } from "../Pages/Auth";
import { Administrar } from "../Pages/Admin/Administrar";

// player pages
import { Home } from "../Pages/Player/Home";
import { Pokedex } from "../Pages/Player/Pokedex";
import { PokedexDetail } from "../Pages/Player/Pokedex/PokedexDetail";
import { Configuracion } from "../Pages/Player/Configuracion";
import { Gashapon } from "../Pages/Player/Gashapon";
import { GashaponV2 } from "../Pages/Player/GashaponV2";
import { GashaponList } from "../Pages/Player/GashaponList"
import { LogrosScreen } from "../Pages/Player/Logros";
import { Cupones } from "../Pages/Player/Cupones"

import { createBrowserRouter, Navigate } from "react-router-dom";
import UserLayout from "../Layout/UserLayout";
import NotFound from "../Pages/Auth/NotFound";
import { EditarPerfil } from "../Pages/Player/EditarPerfil";
import AdminLayout from "../Layout/AdminLayout";
import { ObjetosScreen } from "../Pages/Player/Objetos";
import { Editar } from "../Pages/Admin/Editar";
import { Usuarios } from "../Pages/Admin/Usuarios";
import { Codigos } from "../Pages/Admin/Codigos";
import { Pokemon } from "../Pages/Admin/Pokemon";
import { Perfil } from "../Pages/Admin/Perfil";
import { Configuracion as AdminConfiguracion } from "../Pages/Admin/Configuracion";

// rutas para administrador
export const routesAdmin = createBrowserRouter([
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/administrarUsuarios" replace />,
      },
      {
        path: "administrarUsuarios",
        element: <Usuarios />,
      },
      {
        path: "administrar",
        element: <Administrar />,
      },
      {
        path: "editar",
        element: <Editar />,
      },
      {
        path: "codigos",
        element: <Codigos />,
      },
      {
        path: "pokemon",
        element: <Pokemon />,
      },
      {
        path: "configuracion",
        element: <AdminConfiguracion />,
      },
      {
        path: "perfil",
        element: <Perfil />,
      },
      {
        path: "/*",
        element: <NotFound />,
      },
    ],
  },
]);

// rutas para jugador
export const routesPlayer = createBrowserRouter([
  {
    path: "/",
    element: <UserLayout />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "pokedex",
        element: <Pokedex />,
      },
      {
        path: "objetos",
        element: <ObjetosScreen />,
      },
      {
        path: "pokedex/detalle",
        element: <PokedexDetail />,
      },
      {
        path: "configuracion",
        element: <Configuracion />,
      },
      {
        path: "configuracion/perfil",
        element: <EditarPerfil />,
      },
      {
        path: "configuracion/logros",
        element: <LogrosScreen />,
      },
      {
        path: "gashapon",
        element: <Gashapon />,
      },
      {
        path: "cupones",
        element: <Cupones />,
      },
      {
        path: "/*",
        element: <NotFound />,
      },
      {
        path: "gashaponv2/open",
        element: <GashaponV2 />,
      },
      {
        path: "gashaponv2",
        element: <GashaponList />,
      },
    ],
  },
]);

// rutas de auth
export const routesLogin = createBrowserRouter([
  {
    path: "/login",
    element: <Auth />,
  },
  {
    path: "/*",
    element: <Navigate to={"/login"} replace />,
  },
]);
